import { css } from "@emotion/react";

import SpBentoContents from "~/components/me/bento/SpBentoContents";

const MobilePage = () => {
  return (
    <main css={mainStyle}>
      <SpBentoContents />
    </main>
  );
};

const mainStyle = css`
  margin: 0 8px 0 8px;
  padding-top: 1rem;
`;

export default MobilePage;
